import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import useStyles from './style';
import { Tooltip } from '@material-ui/core';

const SideBarViewer = (props) => {
  const { data, blockState, sideBar, LinkedContractsdataElements, tableData, attachments } = props;

  // State for tab management - default to 'details'
  const [activeTabState, setActiveTabState] = useState('details');
  const [newComment, setNewComment] = useState('');

  const { chartData } = data || {};
  const { LinkedObligationdataElements } = chartData || {};

  const classes = useStyles();

  console.log('tableData**SideBarViewer', attachments);

  const formatAmount = (val, isAmountField, showDoller) => {
    if (isAmountField && showDoller) {
      const cleaned = String(val).replace(/[$,]/g, '').trim();
      const num = Number(cleaned);
      if (!isNaN(num)) {
        return `£${num.toLocaleString()}`;
      }
    }
    return val;
  };

  const supplementalComments = blockState?.supplementalInformationComments || [];

  const handleTabClick = (tabName) => {
    setActiveTabState(tabName);
  };

  const detailsRows = Array.isArray(LinkedObligationdataElements)
    ? LinkedObligationdataElements
    : [];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMinutes = Math.floor((now - date) / (1000 * 60));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes} minutes ago`;

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) return `${diffInHours} hours ago`;

    const diffInDays = Math.floor(diffInHours / 24);
    return `${diffInDays} days ago`;
  };

  const handleAddComment = () => {
    if (newComment.trim()) {
      const newCommentObj = {
        comment: newComment.trim(),
        date: new Date().toISOString(),
        by: props.members?.name || sideBar.labels.unknownUser
      };

      const updatedComments = [...supplementalComments, newCommentObj];
      const updatedBlockState = {
        ...blockState,
        supplementalInformationComments: updatedComments
      };

      const payloadClone = JSON.parse(JSON.stringify(updatedBlockState));
      props.removeIdFields(payloadClone);

      const formData = {
        appId: props.appId,
        dataModelId: chartData?.selectedDataModel,
        dataUniqueId: props.data.chartUniqueId + '_updateobligation',
        opportunityId: props.match.params.id,
        payload: payloadClone,
      };
      props.updateOpportunity(formData);
      setNewComment('');
    }
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const renderTabContent = () => {
    switch (activeTabState) {
      case 'details':
        return (
          <div className={classes.content}>
            <div>
              <div className={classes.sectionHeader}>
                <img src={sideBar.icons.details.inactive} alt="Details" className={classes.tabIcon} />
                <Typography className={classes.sectionTitle}>{sideBar.labels.opportunityDetails}</Typography>
              </div>
              <div>
                {detailsRows.map((res, index) => {
                  const topMarginClass = index === 0 ? classes.rowFirst : classes.rowNotFirst;
                  const isLast = index === detailsRows.length - 1;
                  return (
                    <Grid container key={index} className={classes.gridRow}>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.gridCellLabel,
                          topMarginClass,
                          index === 0 ? classes.cellTopLeft : '',
                          isLast ? classes.cellBottomLeft : '',
                        ].join(' ')}
                      >
                        <Typography className={classes.gridTextLabel}>{res.label}</Typography>
                      </Grid>

                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.gridCellValue,
                          topMarginClass,
                          index === 0 ? classes.cellTopRight : '',
                          isLast ? classes.cellBottomRight : '',
                        ].join(' ')}
                      >
                        <Typography className={classes.gridTextValue}>
                          {blockState && res && res.value && blockState[res.value] ? blockState[res.value] : '-'}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </div>
            </div>
            <div style={{ marginTop: '20px' }}>
              {
                LinkedContractsdataElements.length > 0 && tableData.length > 0 && (
                  <div className={classes.sectionHeader}>
                    <img src={sideBar.icons.details.inactive} alt="Details" className={classes.tabIcon} />
                    <Typography className={classes.sectionTitle}>Contract Details</Typography>
                  </div>
                )
              }

              <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {
                  tableData.length > 0 && tableData.map((obj, index1) => {
                    return (
                      <div key={index1} style={{ marginBottom: index1 === tableData.length - 1 ? '0' : '12px' }}>
                        {
                          LinkedContractsdataElements.map((data, index) => {
                            const topMarginClass = index === 0 ? classes.rowFirst : classes.rowNotFirst;
                            const isLast = index === LinkedContractsdataElements.length - 1;
                            const rawValue = typeof obj[data.value] === 'object' ? obj[data.value]?.value : obj[data.value];
                            const displayValue = formatAmount(rawValue, data.isAmountField, data.showDoller);
                            return (
                              <Grid container key={index} className={classes.gridRow}>
                                <Grid
                                  item
                                  xs={6}
                                  className={[
                                    classes.gridCellLabel,
                                    topMarginClass,
                                    index === 0 ? classes.cellTopLeft : '',
                                    isLast ? classes.cellBottomLeft : '',
                                  ].join(' ')}
                                >
                                  <Typography className={classes.gridTextLabel}>{data.label}</Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  className={[
                                    classes.gridCellValue,
                                    topMarginClass,
                                    index === 0 ? classes.cellTopRight : '',
                                    isLast ? classes.cellBottomRight : '',
                                  ].join(' ')}
                                >
                                  <Typography className={classes.gridTextValue}>
                                    {displayValue !== null && displayValue !== undefined && displayValue !== "" ? (
                                      <Tooltip title={String(displayValue)} arrow>
                                        <span>{String(displayValue)}</span>
                                      </Tooltip>
                                    ) : (
                                      "-"
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>
                            )
                          })
                        }

                      </div>
                    )
                  })
                }
              </div>
            </div>
            <div style={{ marginTop: '20px' }}>
              {
                blockState['supplementalInformation']?.length > 0 && blockState['supplementalInformation']?.length > 0 && (
                  <div className={classes.sectionHeader}>
                    <img src={sideBar.icons.details.inactive} alt="Details" className={classes.tabIcon} />
                    <Typography className={classes.sectionTitle}>Supplemental Information</Typography>
                  </div>
                )
              }

              {
                blockState['supplementalInformation']?.length > 0 ? blockState['supplementalInformation'].map((data, index) => {
                  const topMarginClass = index === 0 ? classes.rowFirst : classes.rowNotFirst;
                  const isLast = index === blockState['supplementalInformation'].length - 1;
                  // const rawValue = typeof obj[data.value] === 'object' ? obj[data.value]?.value : obj[data.value];
                  const displayValue = data.value;
                  return (
                    <Grid container key={index} className={classes.gridRow}>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.gridCellLabel,
                          topMarginClass,
                          index === 0 ? classes.cellTopLeft : '',
                          isLast ? classes.cellBottomLeft : '',
                        ].join(' ')}
                      >
                        <Typography className={classes.gridTextLabel}>{data.label}</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.gridCellValue,
                          topMarginClass,
                          index === 0 ? classes.cellTopRight : '',
                          isLast ? classes.cellBottomRight : '',
                        ].join(' ')}
                      >
                        <Typography className={classes.gridTextValue}>
                          {displayValue !== null && displayValue !== undefined && displayValue !== "" ? (
                            <Tooltip title={String(displayValue)} arrow>
                              <span>{String(displayValue)}</span>
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  )
                }) : null
              }
            </div>
            <div style={{ marginTop: '20px' }}>
              {
                attachments.length > 0 && (
                  <div className={classes.sectionHeader}>
                    <img src={'/media/svg/attachmentIcon.svg'} alt="Details" className={classes.tabIcon} />
                    <Typography className={classes.sectionTitle}>Attachments</Typography>
                  </div>
                )
              }
              {
                attachments.length > 0 && attachments.map((data, index) => {
                  const topMarginClass = index === 0 ? classes.rowFirst : classes.rowNotFirst;
                  const isLast = index === attachments?.length - 1;
                  const displayValue = data.fileName;
                  return (
                    <Grid container key={index} className={classes.gridRow}>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.gridCellLabel,
                          topMarginClass,
                          index === 0 ? classes.cellTopLeft : '',
                          isLast ? classes.cellBottomLeft : '',
                        ].join(' ')}
                      >
                        <Typography className={classes.gridTextLabel}>File Name : </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        className={[
                          classes.gridCellValue,
                          topMarginClass,
                          index === 0 ? classes.cellTopRight : '',
                          isLast ? classes.cellBottomRight : '',
                        ].join(' ')}
                      >
                        <Typography className={classes.gridTextValue}>
                          {displayValue !== null && displayValue !== undefined && displayValue !== "" ? (
                            <Tooltip title={String(displayValue)} arrow>
                              <span>{String(displayValue)}</span>
                            </Tooltip>
                          ) : (
                            "-"
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  )
                })
              }
            </div>
            {/* {
              LinkedContractsdataElements.length > 0 && Object.keys(tableData).length > 0 && (
                <div style={{ marginTop: '12px' }}>
                  <div className={classes.sectionHeader}>
                    <Typography className={classes.sectionTitle}>Contract Details</Typography>
                  </div>
                  <div>
                    {LinkedContractsdataElements.map((data, index) => {
                      const topMarginClass = index === 0 ? classes.rowFirst : classes.rowNotFirst;
                      const isLast = index === LinkedContractsdataElements.length - 1;
                      const rawValue = typeof tableData[data.value] === 'object' ? tableData[data.value]?.value : tableData[data.value];
                      const displayValue = formatAmount(rawValue, data.isAmountField, data.showDoller);
                      return (
                        <Grid container key={index} className={classes.gridRow}>
                          <Grid
                            item
                            xs={6}
                            className={[
                              classes.gridCellLabel,
                              topMarginClass,
                              index === 0 ? classes.cellTopLeft : '',
                              isLast ? classes.cellBottomLeft : '',
                            ].join(' ')}
                          >
                            <Typography className={classes.gridTextLabel}>{data.label}</Typography>
                          </Grid>

                          <Grid
                            item
                            xs={6}
                            className={[
                              classes.gridCellValue,
                              topMarginClass,
                              index === 0 ? classes.cellTopRight : '',
                              isLast ? classes.cellBottomRight : '',
                            ].join(' ')}
                          >
                            <Typography className={classes.gridTextValue}>
                              {displayValue !== null && displayValue !== undefined && displayValue !== "" ? (
                                <Tooltip title={String(displayValue)} arrow>
                                  <span>{String(displayValue)}</span>
                                </Tooltip>
                              ) : (
                                "-"
                              )}
                            </Typography>
                          </Grid>
                        </Grid>
                      )
                    })}
                  </div>
                </div>
              )
            } */}

          </div>
        );

      case 'supplemental':
        return (
          <div className={classes.content}>
            <div className={classes.sectionHeader}>
              <img src={sideBar.icons.supplemental.inactive} alt="Supplemental Info" className={classes.tabIcon} />
              <Typography className={classes.sectionTitle}>{sideBar.labels.supplemental}</Typography>
            </div>

            <div className={classes.supplementalWrap}>
              {supplementalComments.length === 0 ? (
                <div className={classes.emptySupplemental}>
                  {sideBar.labels.noSupplementalInfo}
                </div>
              ) : (
                supplementalComments.map((comment, index) => (
                  <div key={index} className={classes.commentCard}>
                    <div className={classes.commentHeaderRow}>
                      <Avatar className={classes.commentAvatar}>
                        {getInitials(comment.by)}
                      </Avatar>
                      <div className={classes.commentMeta}>
                        <Typography className={classes.commentAuthor}>
                          {comment.by}
                        </Typography>
                        <Typography className={classes.commentDate}>
                          {formatDate(comment.date)}
                        </Typography>
                      </div>
                    </div>
                    <div className={classes.commentBodyRow}>
                      <div className={classes.commentBodySpacer} />
                      <Typography className={classes.commentText}>
                        {comment.comment}
                      </Typography>
                    </div>
                  </div>
                ))
              )}

              <div className={classes.addCommentRow}>
                <Avatar className={classes.commentAvatar}>
                  {getInitials(props.members?.name)}
                </Avatar>

                <div className={classes.addCommentBox}>
                  <textarea
                    className={classes.addCommentTextarea}
                    placeholder={sideBar.labels.addSupplementalPlaceholder}
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    onClick={handleAddComment}
                    disabled={!newComment.trim()}
                    className={`${classes.addCommentButton} ${newComment.trim() ? classes.addCommentButtonActive : classes.addCommentButtonDisabled}`}
                  >
                    {sideBar.labels.addSupplementalInfo}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const detailsActive = activeTabState === 'details';
  const supplementalActive = activeTabState === 'supplemental';

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {/* Details Tab */}
        <div
          className={[classes.tab, detailsActive ? classes.tabActive : ''].join(' ')}
          onClick={() => handleTabClick('details')}
        >
          <div className={classes.tabContent}>
            <img
              src={detailsActive ? sideBar.icons.details.active : sideBar.icons.details.inactive}
              alt="Details"
              className={classes.tabIcon}
            />
            <Typography className={[classes.tabLabel, detailsActive ? classes.tabLabelActive : ''].join(' ')}>
              {sideBar.labels.details}
            </Typography>
          </div>
        </div>

        {/* Supplemental Info Tab */}
        <div
          className={[classes.tab, supplementalActive ? classes.tabActive : ''].join(' ')}
          onClick={() => handleTabClick('supplemental')}
        >
          <div className={classes.tabContent}>
            <img
              src={supplementalActive ? sideBar.icons.supplemental.active : sideBar.icons.supplemental.inactive}
              alt="Supplemental Info"
              className={classes.tabIcon}
            />
            <Typography className={[classes.tabLabel, supplementalActive ? classes.tabLabelActive : ''].join(' ')}>
              {sideBar.labels.supplemental}
            </Typography>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

export default SideBarViewer;
